import React, { useContext, useRef, useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import './styles.scss';
import { fetchAuthSession } from 'aws-amplify/auth';
import { AuthState, cognitoSignOut, changeAuthState } from './helpr/authHelper';
import { IdentityContext, IdentityDispatchContext, IdentityProvider } from './context/identity-context';
import DefaultLayout from './layouts/DefaultLayout';
import ClientLayout from './layouts/ClientLayout';
import CustomForgotPassword from './components/custom-forgot-password/custom-forgot-password';
import CustomLogin from './components/custom-login/custom-login';
import CustomConfirmSignIn from './components/custom-confirm-signin/custom-confirm-signin';
import CustomTOTPSetup from './components/custom-totp-setup/custom-totp-setup';
import CustomRequireNewPassword from './components/custom-require-new-password/custom-require-new-password';
import Invest from './pages/invest/invest';
import PrivacyNotice from './pages/public/privacy-notice/privacy-notice';
import IdleTimer from 'react-idle-timer';
import ModalCustom from './components/modal/modal';
import genericModalStyle from './components/modal/modal.module.scss';
import IdleSessionModalContent from './pages/general/idle-session-modal-content/idle-session-modal-content';
import TermsConditions from './pages/public/terms-conditions/terms-conditions';
import AnnouncementSection from './pages/public/announcements/announcements';
import { queryClient } from './helpr/queryClient';
const SecureApp = ({ showIdle }) => {
  const navigate = useNavigate();
  const { authState, user, modules, role, defaultPath, loading } = useContext(IdentityContext);
  const { clearIdentityContext } = useContext(IdentityDispatchContext);

console.log(
  'SecureApp',
  authState,
  role,
  modules?.length
);
  const TIMEOUT_MINUTES = 15;
  const [timeoutDuration] = useState(1000 * 60 * TIMEOUT_MINUTES);
  const [isTimedOut, setIsTimedOut] = useState(false);
  const idleTimer = useRef();

  const onAction = async () => {
    try { await fetchAuthSession(); setIsTimedOut(false); }
    catch { await forceSignOut(); }
  };

  const onActive = async () => {
    try { await fetchAuthSession(); setIsTimedOut(false); }
    catch { await forceSignOut(); }
  };

  const onIdle = async () => {
    console.log('user is idle', isTimedOut);
    if (!isTimedOut) {
      idleTimer.current.reset();
      setIsTimedOut(true);
      if (authState === AuthState.SignedIn) {
        await forceSignOut();
      } else {
        changeAuthState(AuthState.SignIn);
      }
      showIdle();
    }
  };

  const forceSignOut = async () => {
    try {
      await cognitoSignOut();
      navigate('/');
      localStorage.clear();
      clearIdentityContext();
      try { queryClient.removeQueries(['calendarDates']); } catch (e) {}
    } catch (error) {
      console.log('error signing out:', error.message);
    }
  };

  useEffect(() => {
    if (authState === AuthState.SignedIn && defaultPath) {
      const currentPath = window.location.pathname;
      const isOnValidModule = modules.some(m => currentPath === m.path || currentPath.startsWith(m.path + '/'));
      if (!isOnValidModule) navigate(defaultPath, { replace: true });
    }
  }, [authState, defaultPath]); // eslint-disable-line

  if (loading) return null;

  const isAuthScreen = authState === AuthState.ConfirmSignIn || authState === AuthState.TOTPSetup;

  if (authState === AuthState.SignedIn && user) {
    return (
      <>
        <IdleTimer
          ref={idleTimer}
          element={document}
          onActive={onActive}
          onIdle={onIdle}
          onAction={onAction}
          debounce={250}
          timeout={timeoutDuration}
        />
        <DefaultLayout user={user} role={role} modules={modules} />
      </>
    );
  }

  return (
    <div style={{ height: '100%' }}>
      {isAuthScreen && (
        <IdleTimer
          ref={idleTimer}
          element={document}
          onActive={onActive}
          onIdle={onIdle}
          onAction={onAction}
          debounce={250}
          timeout={timeoutDuration}
        />
      )}
      {(!authState || authState === AuthState.SignIn || authState === AuthState.SignedOut) && <CustomLogin />}
      {authState === AuthState.ConfirmSignIn && <CustomConfirmSignIn />}
      {authState === AuthState.TOTPSetup && <CustomTOTPSetup />}
      {authState === AuthState.ForgotPassword && <CustomForgotPassword />}
      {authState === AuthState.ResetPassword && <CustomRequireNewPassword />}
    </div>
  );
};

const App = () => {
  const [show, setShow] = useState(false);
  return (
    <BrowserRouter>
        <IdentityProvider>
        <Routes>
          <Route path="/client/*" element={<ClientLayout modules={[{ path: '/', name: 'Client', component: Invest, link: false }]} />} />
          <Route path="/privacy-notice/*" element={<ClientLayout modules={[{ path: '/', name: 'Privacy Notice', component: PrivacyNotice, link: false }]} />} />
          <Route path="/terms-conditions/*" element={<ClientLayout modules={[{ path: '/', name: 'Terms and Conditions', component: TermsConditions, link: false }]} />} />
          <Route path="/announcements/*" element={<ClientLayout navheader="LIST OF SELLING AGENTS FOR ONGOING ISSUANCES" modules={[{ path: '/', name: 'Announcement Section', component: AnnouncementSection, link: false }]} />} />
          <Route path="*" element={
            <>
              <SecureApp showIdle={() => setShow(true)} />
              <ModalCustom
                show={show}
                title=""
                onClose={() => setShow(false)}
                component={<IdleSessionModalContent onClose={() => setShow(false)} />}
                style={genericModalStyle['generic']}
              />
            </>
          } />
        </Routes>
      </IdentityProvider>
    </BrowserRouter>
  );
};

export default App;
